import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editResourceGroup(request: Boundaries["editResourceGroup"]["request"]): void;
}

function useEditResourceGroup(group: Identifiable<Group>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isResourceGroupEditionRequestPending(group),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isResourceGroupEditionRequestSuccess(group),
    ),
    isRequestFailure: useSelector(() =>
      selector.isResourceGroupEditionRequestFailure(group),
    ),
    editResourceGroup: core.editResourceGroup,
  };
}

export { useEditResourceGroup };
